import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { bindApi } from "./lib/api";
import { initMonitoring } from "./lib/monitoring";
import { createAppRouter } from "./router";
import "./globals.css";

initMonitoring();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true },
  },
});

const router = createAppRouter(queryClient);
bindApi(queryClient, (to) => {
  void router.navigate({ href: to });
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
